import {
    css, Theme,
} from '@emotion/react'
import common from 'shared/styles'
import custom from 'shared/styles/custom.styles'

const styles = (theme: Theme) => {
    return {
        main: css`
            ${common.fullContainer};
            display: flex;
            justify-content: space-evenly;
            box-sizing: border-box;
            flex-direction: column;
            align-items: center;
            flex-wrap: nowrap;
            padding: 30px 60px;
    `,
        image: css`
            width: 390px;
            height: 230px;
    `,
        message: css`
            ${custom.messageText};
            font-weight: ${theme.typography.fontWeightRegular};
    `,
        button: css`
            ${custom.button};
            padding: 0;
    `,
    }
}

export default styles
